var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAkro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.404 1h-.195l-.172.094L3.803 7.22l-.138.077-.097.123-1.404 1.788L2 9.416v13.026l.147.202 1.02 1.404.097.133.143.08 11.617 6.64.177.1h2.067l.177-.1 11.617-6.64.245-.139.096-.263.511-1.404.047-.127V9.436l-.142-.2-1.277-1.787-.099-.138-.149-.083-10.85-6.128-.175-.1h-1.861zM4.675 8.49 15.6 2.533h1.262L27.39 8.477l1.036 1.45v12.13l-.37 1.013-11.196 6.398h-1.252L4.31 23.012l-.778-1.07V9.946L4.675 8.49zm10.793-2.767h1.491l.175.1 7.13 4.068.147.085.098.139.839 1.186.14.199v8.679l-.046.125-.335.932-.096.264-.243.14-7.632 4.406-.177.103h-1.5l-.178-.104-7.632-4.405-.143-.082-.096-.133-.67-.932-.144-.2V11.48l.161-.208.923-1.186.097-.125.138-.075 7.38-4.067.173-.095zm.394 1.532-7.07 3.896-.664.855v7.793l.43.598 7.312 4.22h.68l7.212-4.162.195-.542v-7.926l-.6-.849-6.805-3.882h-.69zm-.087 2.554h.969l.18.103 3.669 2.143.147.086.097.14.432.626.134.196v4.745l-.043.123-.172.49-.092.264-.24.142-3.93 2.321-.18.108H15.767l-.18-.107-3.928-2.32-.142-.085-.095-.134-.344-.49-.14-.199v-4.876l.156-.205.475-.626.096-.126.138-.077 3.8-2.143.175-.098zm.402 1.53-3.486 1.967-.222.294v3.876l.111.159 3.605 2.13h.143l3.508-2.072.036-.105v-4.006l-.199-.289-3.343-1.953h-.153z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAkro);
export default __webpack_public_path__ + "static/media/AKRO.7a1abf2cc699ca73ac15b5b329bca931.svg";
export { ForwardRef as ReactComponent };